import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaFacebook } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa6";
import adress from "../../constants";
import FooterSocialCard from "../FooterSocialCard/FooterSocialCard";

export default function FooterSocial() {
  const localList = adress;
  return (
    <div className={"flex flex-col items-start"}>
      <h3 className="text-xl font-bold my-4 text-center w-full">
        Social Media
      </h3>
      {/*
       */}
      <div className="flex flex-wrap w-full justify-center pt-4 gap-4">
        {localList.map((local) => {
          return (
            <FooterSocialCard
              data={local}
              key={`soc-${local.id}-${local.city}`}
            />
          );
        })}
      </div>
    </div>
  );
}
